<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Cihaz Güncelleme">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek cihaz adı ,imei no benzersiz
                olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/devices"
          >
            Cihaz Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Cihaz Güncelleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Hava Limanları" label-for="airports">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Hava Limanları"
                  >
                    <v-select
                      id="airports"
                      v-model="selectedAirports"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="airports"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div>
                  <b-button
                    class="float-right"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    v-on:click="addAllAirports"
                  >
                    Tümünü Ekle
                  </b-button>
                  <b-button
                    class="float-right mr-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    v-on:click="removeAllAirports"
                  >
                    Tümünü Kaldır
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Cihaz IMEI" label-for="deviceImei">
                  <validation-provider
                    #default="{ errors }"
                    vid="deviceImei"
                    :rules="{ required: true, min: 15, max: 15 }"
                    name="Cihaz IMEI"
                  >
                    <b-form-input
                      id="deviceImei"
                      type="number"
                      v-model="deviceImei"
                      placeholder="Cihaz IMEI"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Cihaz Adı" label-for="deviceName">
                  <validation-provider
                    #default="{ errors }"
                    vid="deviceName"
                    :rules="{ required: true }"
                    name="Cihaz Adı"
                  >
                    <b-form-input
                      id="deviceName"
                      type="text"
                      v-model="deviceName"
                      placeholder="Cihaz Adı"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                      @keyup="deviceNameKeyup"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label="Giriş Sayısı" label-for="loginCount">
                  <validation-provider
                    #default="{ errors }"
                    vid="loginCount"
                    :rules="{ required: true }"
                    name="Cihaz Adı"
                  >
                    <b-form-input
                      id="loginCount"
                      type="text"
                      v-model="loginCount"
                      placeholder="Cihaz Adı"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label="Tek Kullanımlık Giriş" label-for="oneTimeLogin">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Durum"
                  >
                    <b-form-checkbox id="oneTimeLogin" :checked="true" switch v-model="oneTimeLogin" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Aktif" label-for="active">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Aktif"
                  >
                    <b-form-checkbox id="active" :checked="true" switch v-model="active" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col md="12">
                <div class="media d-flex align-items-center mb-2">
                  <p class="mr-auto mb-0">Cihaz Parolasını Değiştirmek İstiyorum</p>
                  <b-form-checkbox :checked="true" switch v-model="passwordChange" />
                </div>
              </b-col>
            </b-row> -->
            <b-row v-if="passwordChange == true">
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  vid="password"
                  :rules="{ required: passwordChange, min: 8, max: 16 }"
                  name="Parola"
                >
                  <b-form-group label="Parola" label-for="password">
                    <b-form-input
                      id="password"
                      :type="passwordFieldType"
                      v-model="password"
                      placeholder="Parola"
                      autocomplete="off"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row v-if="passwordChange == true">
              <b-col md="12">
                <b-form-group label="Parola Tekrarı" label-for="passwordConfirmation">
                  <validation-provider
                    #default="{ errors }"
                    vid="password"
                    :rules="{ required: passwordChange, min: 8, max: 16 }"
                    name="Parola Tekrarı"
                  >
                    <b-form-input
                      id="passwordConfirmation"
                      :type="passwordFieldType"
                      v-model="passwordConfirmation"
                      placeholder="Parola Tekrarı"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import {
  BPagination,
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
  BBadge,
  BInputGroupAppend,
  BButtonGroup,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
const endpoints = new Endpoints();

export default {
  components: {
    BPagination,
    BBadge,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    BInputGroupAppend,
    BButtonGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      id: this.$route.params.idParam,
      rows: 100,
      baseUrl: settings.apiBaseUrl,
      active: true,
      loginCount: 0,
      oneTimeLogin: true,
      airports: [],
      password: "",
      deviceId: "",
      deviceName: "",
      deviceImei: "",
      selectedAirports: [],
      passwordConfirmation: "",
      passwordChange: false,
      spinner: false,
    };
  },

  methods: {
    deviceNameKeyup() {
      this.deviceName = this.deviceName
        .replace(/[^a-zA-Z0-9]/g, "")
        .split(" ")
        .join("")
        .trim()
        .toLowerCase();
    },
    addAllAirports() {
      this.selectedAirports = [...this.airports];
    },
    removeAllAirports() {
      this.selectedAirports = [];
    },
    getDeviceById() {
      endpoints
        .getDeviceById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.active = data.response.active;
          this.loginCount = data.response.loginCount;
          this.oneTimeLogin = data.response.oneTimeLogin;
          this.deviceName = data.response.deviceName;
          this.deviceImei = data.response.deviceImei;

          data.response.deviceAirportIds.forEach((element) => {
            let selectedAirport = this.airports.find((airport) => airport.id === element);
            this.selectedAirports.push(selectedAirport);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllAirports() {
      endpoints
        .getAllAirports(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.getDeviceById();
          this.airports = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Cihazı güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let deviceAirports = [];
          for (let i = 0; i < this.selectedAirports.length; i++) {
            deviceAirports.push(this.selectedAirports[i].id);
          }
          endpoints
            .putDevices(
              {
                id: this.id,
                active: this.active,
                oneTimeLogin: this.oneTimeLogin,
                loginCount: this.loginCount,
                deviceImei: this.deviceImei,
                deviceName: this.deviceName,
                deviceAirports: deviceAirports,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
              },
              this.$i18n.locale,
              () => {}
            )
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Cihaz Güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                         path: `/devices`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Cihaz benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  mounted() {
    this.getAllAirports();
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
